import React, { FC, useEffect } from 'react';
import { PageLink, PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';
import {
	exportCSVFundsReserveTable,
	fetchFundsReserveList,
	setFundsReserveListToDefault,
} from '../../store/order/actions/funds-reserve';
import { useOrdersContext } from '../../store/order/order-context';
import { useMerchants } from '../../store/merchnts/merchants-context';
import clsx from 'clsx';
import { ButtonLoading } from '../../components/ButtonLoading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

export const fundsBreadCrumbs: Array<PageLink> = [
	{
		title: 'MENU.FUNDS',
		path: '/funds/payouts',
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export const FundsReservePage: FC = () => {
	const { t } = useTranslation();
	const { merchantState: { chosenMerchant }} = useMerchants();
	const { orderContextState, dispatch } = useOrdersContext();
	const {
		fundsReserveList,
		isFundsReserveListLoading,
		isExportCSVLoading
	} = orderContextState;

	const [selectedFundReserve, setSelectedFundReserve] = React.useState<string>('');


	useEffect(() => {
		void fetchFundsReserveList(dispatch, orderContextState, chosenMerchant);
	}, []);

	useEffect(() => {
		return () => {
			void setFundsReserveListToDefault(dispatch);
		};
	}, []);

	const rowActions = (rowData): JSX.Element => {
		const handleRowClick = (): void => {
			setSelectedFundReserve(rowData?.original?.mid);
			void exportCSVFundsReserveTable(dispatch, rowData?.original?.mid);
		};

		return (
			<div
				className={clsx(
					'd-flex align-items-center justify-content-center',
					isExportCSVLoading ? 'cursor-not-allowed' : 'cursor-pointer',
				)}
				onClick={!isExportCSVLoading && handleRowClick}
			>
			<div className="text-muted fw-bolder">
				Export CSV
			</div>
				{
					isExportCSVLoading && selectedFundReserve === rowData?.original?.mid
						? <ButtonLoading additionalClass="ms-2 text-muted" />
						: <FontAwesomeIcon icon={faFileCsv} width={15} className="text-muted ms-2 h-15px" />
				}
			</div>
		);
	};

	return (
		<>
			<PageTitle breadcrumbs={fundsBreadCrumbs}>{t('MENU.FUNDS_RESERVE')}</PageTitle>

			<Table
				name={TablesNames.reserveFundTableData}
				data={fundsReserveList}
				isLoading={isFundsReserveListLoading}
				enableRowActions={true}
				rowActions={rowActions}
				actionColumnsSize={75}
			/>
		</>
	);
};